import React, {useEffect, useState} from "react";
import NavLink from "react-bootstrap/NavLink";
import SpinNumber from "../components/mpSpinNumber";

const AppCartInfo = (props) => {

    // Склонение числительных declOfNum(count, ['товар', 'товара', 'товаров']);
    function declOfNum(number, titles) {
        const cases = [2, 0, 1, 1, 1, 2];
        return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    }

    const textSelected = `${declOfNum(props.count, ['Выбран', 'Выбрано', 'Выбрано'])} ${props.count} ${declOfNum(props.count, ['товар', 'товара', 'товаров'])}`

    return (
        <div className="position-relative bg-light h-100">
            <div className="position-sticky p-6 top-0">
                {props.count > 0 ? (
                    <h4>{textSelected}</h4>
                ) : (
                    <div className="fs-4">
                        <div>Выберите товары, чтобы оформить заказ</div>
                        <button type="button"
                                className="btn btn-secondary btn-carbonus mt-3"
                                onClick={props.changeAllCheck}>
                            Выбрать товары
                        </button>
                    </div>
                )}

                {props.count > 0 && (
                    <>
                        <ul className="list-unstyled fs-4 my-6">
                            <li className="row flex-nowrap mt-2">
                                <div className="col">Товары</div>
                                <div className="col-auto text-nowrap">
                                    <SpinNumber
                                        val={props.itemsTotalPrice}
                                        time={50}
                                        isFormating={true}
                                    />
                                </div>
                            </li>
                            <li className="row flex-nowrap mt-2">
                                <div className="col-auto">Доставка</div>
                                <div className="col text-end text-muted fs-5">
                                    будет рассчитана<br/>при&nbsp;оформлении заказа
                                </div>
                            </li>
                            <li className="row flex-nowrap mt-2 fw-bold">
                                <div className="col">Итого</div>
                                <div className="col-auto text-nowrap">
                                    <SpinNumber
                                        val={props.totalPrice}
                                        time={50}
                                        isFormating={true}
                                    />
                                </div>
                            </li>
                        </ul>
                        <a href="/orders/create"
                           className={`btn btn-carbonus btn-hg rounded-4 w-100${!props.count ? ' disabled' : ''}`}>
                            Оформить заказ
                        </a>
                    </>
                )}
            </div>
        </div>
    )
}

export default AppCartInfo;
